import type {
  RoadmapListResponse,
  SubmitSuggestionRequest,
  SubmitSuggestionResponse,
  VoteResponse,
} from '@smartapply/shared';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3030';

export class SiteApiError extends Error {
  public readonly code: string;
  public readonly status: number;

  constructor(code: string, message: string, status: number) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

async function handle<T>(res: Response): Promise<T> {
  if (res.status === 204) return undefined as T;
  if (res.ok) return (await res.json()) as T;
  let payload: { error?: { code: string; message: string } } = {};
  try {
    payload = (await res.json()) as typeof payload;
  } catch {
    /* sem body */
  }
  throw new SiteApiError(
    payload.error?.code ?? `http_${res.status}`,
    payload.error?.message ?? `HTTP ${res.status}`,
    res.status,
  );
}

export async function fetchRoadmap(): Promise<RoadmapListResponse> {
  const res = await fetch(`${API_URL}/api/v1/roadmap`, {
    credentials: 'include',
  });
  return handle<RoadmapListResponse>(res);
}

export async function voteForItem(itemId: string): Promise<VoteResponse> {
  const res = await fetch(`${API_URL}/api/v1/roadmap/${itemId}/vote`, {
    method: 'POST',
    credentials: 'include',
  });
  return handle<VoteResponse>(res);
}

export async function submitSuggestion(
  payload: SubmitSuggestionRequest,
): Promise<SubmitSuggestionResponse> {
  const res = await fetch(`${API_URL}/api/v1/suggestions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handle<SubmitSuggestionResponse>(res);
}
